import React from 'react';
import PropTypes from 'prop-types';

export const ForeignExchange = ({ width, height, ...props }) => (
  <svg
    data-icon='foreign-exchange'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M7 20v-2H5V6h2V4h2v2h2v12H9v2H7Zm0-4h2V8H7v8Zm8 4v-5h-2V8h2V4h2v4h2v7h-2v5h-2Zm0-7h2v-3h-2v3Z'
    />
  </svg>
);

ForeignExchange.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ForeignExchange.defaultProps = {
  width: 24,
  height: 24,
};
